import React, { useEffect, useMemo } from "react";
import { MainPageLayoutContainer } from "@obsbot/remo-pages/src/components/MainPageLayoutContainer";
import { usePageStore } from "@obsbot/remo-pages/src/stores/page-store";
import { Outlet } from "react-router-dom";
import { useRTMStore } from "@obsbot/remo-pages/src/utils/use-rtm-store";

export const MainPageLayoutWrapper: React.FC = () => {
    const pageStore = usePageStore();
    const stableConfig = useMemo(() => ({}), []);
    // 初始化rtm;
    useRTMStore(stableConfig);

    useEffect(() => {
        window.addEventListener("keydown", e => {
            if (e.ctrlKey && e.key === "+") {
                e.preventDefault();
            } else if (e.ctrlKey && e.key === "-") {
                e.preventDefault();
            }
        });
    }, []);
    return (
        <MainPageLayoutContainer activeKeys={pageStore.activeKeys} subMenu={pageStore.subMenu}>
            <Outlet />
        </MainPageLayoutContainer>
    );
};
